import React from 'react';
import GoalIcon from '@atlaskit/icon/core/goal';
import { GOALS_CF_TYPE } from '@atlassian/jira-platform-field-config';
import type { GetIconFunction } from '../../../icon/types';

export const getGoalsIcons: GetIconFunction = () => ({
	[GOALS_CF_TYPE]: <GoalIcon label="" spacing="spacious" />,
});
